export default __webpack_public_path__ + "static/media/background.b7f0411a.jpg";